import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthEffects } from './core/ngrx/effect/auth.effect';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './reducers';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { config } from '../environments/config';
import {
  DatanyzeCommonModule,
  UserNotificationInterceptor,
} from '@dn/libs/ui/dn-common';
import { BackendInterceptorService } from './core/service/backend-interceptor/backend-interceptor.service';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from './core/service/notifications/notification.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PlatformCommonModule } from './common/common.module';
import { NotificationEffects } from './core/ngrx/effect/notification.effect';
import { MobileBlockModule } from './common/component/mobile-block/mobile-block.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_CONFIG } from './tokens/app-config.token';
import { CommonModule as AngularCommonModule } from '@angular/common';

const imports = [
  AngularCommonModule,
  BrowserModule,
  RouterModule,
  AppRoutingModule,
  EffectsModule.forRoot([AuthEffects, NotificationEffects]),
  StoreRouterConnectingModule.forRoot(),
  StoreModule.forRoot(reducers, {
    metaReducers,
    runtimeChecks: {
      strictStateImmutability: true,
      strictActionImmutability: true,
    },
  }),
  DatanyzeCommonModule,
  MatSnackBarModule,
  PlatformCommonModule,
  MobileBlockModule,
  BrowserAnimationsModule,
];

if (!config.production) {
  imports.push(StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: config.production }));
}

@NgModule({
  declarations: [AppComponent],
  imports,
  providers: [
    {
      provide: APP_CONFIG,
      useValue: config,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserNotificationInterceptor,
      multi: true,
    },
    NotificationService,
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(withEventReplay()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
